var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconNavigationExpandMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.59 8.295L12 12.875l-4.59-4.58L6 9.705l6 6 6-6z",
    fill: "#FFF"
  })));
}

export default __webpack_public_path__ + "760714e178f7cc170bc9e27ab8e03996.svg";
export { SvgIconNavigationExpandMore as ReactComponent };